export default {
  data: function data() {
    return {
      show: false,
      message: '',
      isMask: false
    };
  }
};